import * as RadixDropdownMenu from '@radix-ui/react-dropdown-menu';

export function DropdownMenuSeparator() {
  return <RadixDropdownMenu.Separator className="my-1 h-px w-full bg-neutral-200" />;
}
